export default __webpack_public_path__ + "static/media/qzuki-hero-dark.7b5f4e98.png";